module.exports = __webpack_public_path__ + "img/wb_o_office-donegal.b6ac858d.svg";